module.exports = __webpack_public_path__ + "img/12a-doc-documento-show.dc358235.png";